import request, { formatRequest } from "@/utils/request"

import { AddTimeLineParams, TimeLineItem } from "./type"

interface trackingDetailsProps {
  request_id: number
  tracking_number: string
}

interface timeLineDetailsProps {
  request_id: number
}

export interface WarehouseItem {
  /**
   * 地址
   */
  address1: string
  /**
   * 地址
   */
  address2: string
  /**
   * 城市
   */
  city: string
  /**
   * 国家
   */
  country: string
  /**
   * id
   */
  id: number
  /**
   * 是否已选择
   */
  is_selected: boolean
  /**
   * 名称
   */
  name: string
  /**
   * 电话
   */
  phone_number: string
  state: string
  timezone: string
  /**
   * 编码
   */
  zip_code: string
}

const APIAddons = {
  /**
   * 是否展示pp tracking推荐banner
   */
  getTrackingShowBanner() {
    return formatRequest(request.get("/go-api/v1/tracking/show_banner"))
  },

  /**
   * 关闭pp banner
   */
  CloseTrackingBanner() {
    return formatRequest(request.post("/go-api/v1/tracking/close_banner"))
  },

  /**
   * 关闭物流标签异步任务提示 Banner
   */
  closeLabelAsyncBanner(params: { request_id: number }) {
    return formatRequest(
      request.post("/go-api/v1/tracking/close_label_async_banner", params),
      { hideMsg: true },
    )
  },

  /**
   * 连接信息
   */
  getTrackingConnectInfo() {
    return formatRequest(request.get("/go-api/v1/tracking/connect_info"))
  },

  /**
   * 建立连接 (keyApi无效无需toast提示)
   */
  setTrackingConnect() {
    return formatRequest(request.post("/go-api/v1/tracking/connect"))
  },

  /**
   * 断开连接
   */
  setTrackingDisconnect() {
    return formatRequest(request.post("/go-api/v1/tracking/disconnect"), {
      success: {
        1000: "Operation successful",
      },
      error: {
        "*": "Operation failed",
      },
    })
  },

  /**
   * 物流轨迹
   */
  getTrackingDetails(params: trackingDetailsProps) {
    return formatRequest(request.get("/go-api/v1/tracking/details", { params }))
  },

  /**
   * 操作时间线信息
   * request_id: 退货申请ID
   */
  getTimeLineDetails(params: timeLineDetailsProps, scenario?: string) {
    if (scenario) {
      return formatRequest<TimeLineItem[]>(
        request.get("/go-api/v1/management/sandbox/return/timeLine", {
          params: {
            scenario,
          },
        }),
      )
    }

    return formatRequest<TimeLineItem[]>(
      request.get("/go-api/v1/management/return/time_line", {
        params: {
          request_id: params.request_id,
        },
      }),
    )
  },

  /**
   * 添加操作时间线信息
   * request_id: 退货申请ID
   */
  addTimeLineDetails(params: AddTimeLineParams, scenario?: string) {
    if (scenario) {
      return formatRequest(
        request.post("/go-api/v1/management/sandbox/return/addTimeLine", {
          scenario,
          content: params.content,
          files: params.files,
        }),
        {
          success: {
            1000: t("PostedSuccessfully"),
          },
          error: {
            "*": t("PostedFailed"),
          },
        },
      )
    }

    return formatRequest(
      request.post("/go-api/v1/management/return/add_time_line", {
        content: params.content,
        request_id: params.request_id,
        files: params.files,
      }),
      {
        success: {
          1000: t("PostedSuccessfully"),
        },
        error: {
          "*": t("PostedFailed"),
        },
      },
    )
  },

  /**
   * 获取集成绑定情况列表
   */
  getIntegrationList() {
    return formatRequest(request.get("/go-api/v1/integration/other/list"))
  },

  /**
   * 取消绑定集成
   * name: 集成名称 wise、parcelpanel
   */
  unbindingIntegration(params: { name: string }) {
    return formatRequest(
      request.get("/go-api/v1/integration/other/unbinding", { params }),
      {
        success: {
          1000: t("RemovedSuccessfully"),
        },
        error: {
          "*": t("OperationFailed"),
        },
      },
    )
  },

  /**
   * 绑定集成
   */
  bindingIntegration(params: {
    name: string
    api_token: string
    profile_id?: number
    profile_type?: string
  }) {
    return formatRequest(
      request.post("/go-api/v1/integration/other/binding", params),
      {
        success: {
          1000: t("LinkedSuccessfully"),
        },
        error: {
          "7": t("PleaseEnterAValidApiToken"),
          "*": t("OperationFailed"),
        },
      },
    )
  },
  /**
   * 绑定集成
   */
  updateShipbobWarehouse(data: { items: WarehouseItem[] }) {
    return formatRequest(
      request.post("/go-api/v1/integration/shipbob/updateWarehouse", data),
      {
        success: {
          1000: t("OperationSuccessful"),
        },
        error: {
          "*": t("OperationFailed"),
        },
      },
    )
  },
  /**
   * 绑定集成
   */
  getWarehouseList() {
    return formatRequest(
      request.post<WarehouseItem[]>("/go-api/v1/integration/shipbob/warehouse"),
    )
  },

  /**
   * 绑定集成
   */
  getWiseProfiles(params: { api_token: string }) {
    return formatRequest(
      request.post("/go-api/v1/integration/wise/profiles", params),
      {
        hideMsg: true,
      },
    )
  },
}

export default APIAddons
